import React, { useEffect, useState, useRef, useContext } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import $ from 'jquery';
import { CheckSession, FormatCurrency, GetCoockie, GetShoppingCart } from "../GlobalScript";
import { ShoppingCartContext } from './ShoppingCartContext';
import Cookies from 'js-cookie';
import PaginationBar from '../PaginationBar';
import PulseLoader from "react-spinners/PulseLoader";
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Table from 'react-bootstrap/Table';
import Modal from 'react-bootstrap/Modal';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import InputGroup from 'react-bootstrap/InputGroup';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import FooterDealer from '../FooterDealer.js';

export default function BackOrders() {

    //const navigate = useNavigate();
    const countPerPage = 25;
    const [pageResults, setPageResults] = useState(countPerPage);
    const [tempPage, setTempPage] = useState(countPerPage);
    const [resultsLength, setResultsLength] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [orderItems, setOrderItems] = useState([]);
    const [loading, setLoading] = useState(true);
    //const [keyword, setKeyword] = useState('');
    //const [status, setStatus] = useState('');
    //const [dateFrom, setDateFrom] = useState('');
    //const [dateTo, setDateTo] = useState('');
    const [activeRow, setActiveRow] = useState(null);
    const dropdownRef = useRef(null);
    const [itemOffset, setItemOffset] = useState(0);
    const endOffset = itemOffset + pageResults;

    const pageCount = Math.ceil(orderItems.length / pageResults);
    const currentItems = orderItems.slice(itemOffset, endOffset);
    //const location = useLocation();
    //const [OrderStatusList, setOrderStatusList] = useState(false);
    const { shoppingCart, setShoppingCart } = useContext(ShoppingCartContext);
    const [actionMap, setActionMap] = useState(new Map());
    const [qtyMap, setQtyMap] = useState(new Map());
    const [dropdownText, setDropdownText] = useState([]);
    const [pop, setPop] = useState(false);
    const [allItemsMap, setAllItemsMap] = useState(new Map());

    useEffect(() => {
        setShoppingCart(GetShoppingCart(shoppingCart));
        document.title = 'K-Dealer - Back Orders';
    }, []);

    const handlePop = () => setPop(true);
    const handleClosePop = () => setPop(false);

    //useEffect(() => {
    //    if (location.state && location.state.id && location.state.id !== '') {
    //        LoadOrders();
    //    }
    //}, [keyword])

    useEffect(() => {
        if (loading === true) {
            LoadOrders();
            handlePop();
        } else {
            handleClosePop();
        }
    }, [loading]);

    //useEffect(() => {
    //    if (!OrderStatusList) {
    //        LoadOrderStatusList();
    //    }
    //}, [OrderStatusList]);

    //const LoadOrderStatusList = async () => {
    //    try {
    //        CheckSession();
    //        const response = await fetch("kdealer/GetOrderStatusList");
    //        if (response.status !== 200) {
    //            return;
    //        }
    //        const lst = await response.json();
    //        setOrderStatusList(lst);
    //        console.log(lst)
    //    } catch (e) {
    //        console.log(e);
    //        return;
    //    }
    //}

    const LoadOrders = async () => {
        try {
            CheckSession();
            const user = GetCoockie();
            const data = {
                value: user.userKey.toString(),
                label: user.dealerID
            }
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify(data)
            };
            const response = await fetch("kdealer/GetBackOrderList", requestOptions);
            if (response.status !== 200) {
                return;
            }
            const orders = await response.json();
            const map = new Map();
            orders.map((item) => {
                map.set(item.orderNbr + "," + item.itemNbr, item);
                updateQty(item, parseInt(item.bOQty));
                return '';
            });
            setAllItemsMap(map);
            setOrderItems(orders);
            setResultsLength(orders.length);
            setDropdownText(new Array(orders.length).fill(''));
        } catch (e) {
            console.log(e);
        } finally {
            setLoading(false);
        }
    }

    const handleChange = (event) => {
        const { name, value } = event.target;
        if (name === 'tempPage') {
            setTempPage(value);
        }
    }

    const handlePageClick = (input) => {
        const pageIndex = typeof input === "number" ? input : input.selected;
        const newOffset = pageIndex * pageResults;
        setCurrentPage(pageIndex);
        setItemOffset(newOffset);
    };

    const changePageResults = () => {
        if (tempPage && tempPage > 0 && tempPage < 1000) {
            const newSize = Number(tempPage) || 1; // basic safety 
            setPageResults(newSize);
            setCurrentPage(0);
            setItemOffset(0);
        }
    };

    const updateActionCode = async (item, type, index) => {
        const id = item.orderNbr + "," + item.itemNbr;
        const acmap = new Map(actionMap);
        if (type <= 0 || type > 3) {
            acmap.delete(id);
        } else {
            acmap.set(id, type);
        }

        if (type === 0) {
            //reset
            setDropdownText((prevArray => {
                const updatedArray = [...prevArray];
                updatedArray[index] = '';
                return updatedArray;
            }));
        } else if (type === 1) {
            setDropdownText((prevArray => {
                const updatedArray = [...prevArray];
                updatedArray[index] = 'Cancel';
                return updatedArray;
            }));
        } else if (type === 2) {
            //retian
            //retain
            setDropdownText((prevArray => {
                const updatedArray = [...prevArray];
                updatedArray[index] = 'Retain';
                return updatedArray;
            }));
        } else if (type === 3) {
            //modify
            setDropdownText((prevArray => {
                const updatedArray = [...prevArray];
                updatedArray[index] = 'Modify';
                return updatedArray;
            }));
        }

        setActionMap(acmap);
    }

    const updateQty = async (item, qtyValue) => {
        //setTempBOQty(qtyValue)
        const map = new Map(qtyMap);
        map.set(item.orderNbr + "," + item.itemNbr, qtyValue);
        setQtyMap(map);
    }

    const getActionCode = (type, index) =>{
        if (type === 1) {
            return "C";
        } else if (type === 2) {
            return "R";
        } else if (type === 3) {
            return "M";
        } else {
            return "";
        }
    }

    const handleUpdate = async () => {
        //maby a msg to ask them to double check?
        try {
            handlePop();
            CheckSession();
            const user = GetCoockie();
            const arr = [];

            actionMap.forEach((value, key) => {
                console.log(`Key: ${key}, Value: ${value}`);
                const actionCode = actionMap.get(key);
                const copiedObject = { ...allItemsMap.get(key), "actionCode": getActionCode(actionMap.get(key)) };
                if (actionCode === 3 && qtyMap.has(key)) {
                    copiedObject.bOQty = qtyMap.get(key).toString();
                }
                arr.push(copiedObject);
            });
            const data = {
                dealerID: user.dealerID,
                items: arr
            }
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify(data)
            };
            const response = await fetch("kdealer/UpdateBackOrder", requestOptions);
            if (response.status !== 200) {
                //need error msg
                return;
            }
            await LoadOrders();
            //need confirmation msg

        } catch (e) {
            console.log(e);
        } finally {
            handleClosePop();
        }
    }

    return (
        <>
            <Container className="checkout-container main-container dealer-section">

                <Row className="help-title-row checkout-title-row">
                    <Col className="help-center-title checkout-title">
                        <h1 className="heading help-heading">BACK ORDERS</h1>
                    </Col>
                    <Col className="checkout-title-under"></Col>
                </Row>

                {/*<Row>*/}
                {/*    <Col sm={12}>*/}
                {/*        <Card>*/}
                {/*            <Card.Body>*/}
                {/*                <Row>*/}
                {/*                    <Col sm={3}>*/}
                {/*                        <FloatingLabel label="Keyword" className="mb-4">*/}
                {/*                            <Form.Control id="keyword" type="text" placeholder="Keyword" value={keyword} className={'form-control'} onChange={handleChange} name="keyword" />*/}
                {/*                        </FloatingLabel>*/}
                {/*                    </Col>*/}
                {/*                    <Col sm={3}>*/}
                {/*                        <Form.Select aria-label="Status" onChange={handleChange} value={status} name="status" className="tall-select">*/}
                {/*                            <option value={''}>All</option>*/}
                {/*                            {*/}
                {/*                                OrderStatusList && OrderStatusList.map((item, index) => (*/}
                {/*                                    <option key={item.value} value={item.value}>{item.label}</option>*/}
                {/*                                ))*/}
                {/*                            }*/}
                {/*                        </Form.Select>*/}
                {/*                    </Col>*/}
                {/*                    <Col sm={3}>*/}
                {/*                        <FloatingLabel label="Date From" className="mb-4">*/}
                {/*                            <Form.Control id="dateFrom" type="text" placeholder="Date From" value={dateFrom} className={'form-control'} onChange={handleChange} name="dateFrom" />*/}
                {/*                        </FloatingLabel>*/}
                {/*                    </Col>*/}
                {/*                    <Col sm={3}>*/}
                {/*                        <FloatingLabel label="Date To" className="mb-4">*/}
                {/*                            <Form.Control id="dateTo" type="text" placeholder="Date To" value={dateTo} className={'form-control'} onChange={handleChange} name="dateTo" />*/}
                {/*                        </FloatingLabel>*/}
                {/*                    </Col>*/}

                {/*                    <Col sm={{ offset: 8 }} className="text-right" style={{ alignSelf: 'center' }}>*/}
                {/*                        <p className="clickable underline green-text" onClick={ResetSearch }>Reset Search</p>*/}
                {/*                    </Col>*/}

                {/*                    <Col className="text-center mb-3">*/}
                {/*                        <Button variant="secondary"  onClick={handleSearchClick}>*/}
                {/*                            <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">*/}
                {/*                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />*/}
                {/*                            </svg>*/}
                {/*                            SEARCH*/}
                {/*                        </Button>*/}
                {/*                    </Col>*/}
                {/*                </Row>*/}
                {/*            </Card.Body>*/}
                {/*        </Card>*/}
                {/*    </Col>*/}
                {/*</Row>*/}

                <Row>
                    <Col sm={12}>
                        <Card>
                            <Card.Body>
                                <Row>
                                    <Col sm={12}>
                                        <h5>Item PO / Availability Status Legend</h5>
                                        <p><span className="bold">In Transit to KMC</span> - Shipment is in transit and on time</p>
                                        <p><span className="bold">In Transit to KMC - Past Due</span> - Shipment is in transit but experiencing a delay</p>
                                        <p><span className="bold">On Order</span> - Purchase order has been submitted to supplier</p>
                                        <p><span className="bold">On Order - Past Due</span> - Purchase order has been submitted to supplier but has not been fulfilled yet</p>
                                        <p><span className="bold">Dock Arrival</span> - Incoming shipment has arrived at KMC warehouse</p>
                                        <p><span className="bold">Available</span> - Parts have arrived at KMC and will allocate soon</p>
                                        <p><span className="bold">(Blank)</span> - Date will be updated as soon as information becomes available. Check back later.</p>

                                        <h5>Please be aware that the dates shown here are a direct representation of what our representatives can see.</h5>
                                        <h5>****Due to current supply chain constraints some items may experience a longer than normal lead time.****</h5>
                                        <h5>CAUTION: Do not make firm customer commitments based on this information.</h5>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row className="mt-4 mb-4">
                    <Col sm={12}>
                        <Card className="">
                            <Card.Body>
                                {/*<Row className="table-legend text-center">*/}
                                {/*    <Col sm={12}>*/}
                                {/*        <div className="table-legend-section">*/}
                                {/*            <span className="svg-holder"><img src="../../../Images/parts.svg" alt="" className="" /> Parts</span>*/}
                                {/*            <span className="svg-holder"><img src="../../../Images/accessories.svg" alt="" className="" /> Accessories</span>*/}
                                {/*            <span className="svg-holder"><img src="../../../Images/other.svg" alt="" className="" /> Other</span>*/}
                                {/*        </div>*/}
                                {/*        <div className="table-legend-section">*/}
                                {/*            <span className="svg-holder"><img src="../../../Images/partially-shipped.svg" alt="" className="" /> Partially Shipped</span>*/}
                                {/*            <span className="svg-holder"><img src="../../../Images/shipped-active.svg" alt="" className="" /> Shipped</span>*/}
                                {/*            <span className="svg-holder"><img src="../../../Images/returned.svg" alt="" className="" /> Returned</span>*/}
                                {/*            <span className="svg-holder"><img src="../../../Images/queued.svg" alt="" className="" /> Queued</span>*/}
                                {/*            <span className="svg-holder"><img src="../../../Images/cancelled-inactive.svg" alt="" className="" /> Cancelled</span>*/}
                                {/*        </div>*/}
                                {/*        <div className="table-legend-section">*/}
                                {/*            <span className="svg-holder"><img src="../../../Images/backorder.svg" alt="" className="" /> Backorder</span>*/}
                                {/*        </div>*/}
                                {/*    </Col>*/}
                                {/*</Row>*/}

                                <PaginationBar
                                    resultsLength={resultsLength}
                                    pageCount={pageCount}
                                    currentPage={currentPage}
                                    pageResults={pageResults}
                                    tempPage={tempPage}
                                    onTempPageChange={handleChange}
                                    onPageResultsChange={changePageResults}
                                    onPageChange={handlePageClick}
                                />

                                <Row>
                                    <Col sm={12} className="order-table">
                                        <Table hover responsive>
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>ITEM #</th>
                                                    <th>DESCRIPTION</th>
                                                    <th>MEMO</th>
                                                    <th>ORDER <br /> #</th>
                                                    <th>ORDER <br /> TYPE</th>
                                                    <th>ITEM PO <br /> AVAILABILITY STATUS</th>
                                                    <th>EST. SHIP <br /> DATE</th>
                                                    <th>CANCEL <br /> DATE</th>
                                                    <th>ACTION <br /> CODE</th>
                                                    <th>PACKAGE <br /> QTY</th>
                                                    <th>BKORD <br /> QTY</th>
                                                    <th>SHIPPING <br /> METHOD</th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                                {currentItems && currentItems.map((item, index) => (
                                                    <tr className="" key={item.orderNbr + item.itemNbr}>
                                                        <td>{(currentPage * pageResults) + index + 1}</td>
                                                        <td className="bold">{item.itemNbr}</td>
                                                        <td>{item.itemDesc}</td>
                                                        <td>{item.memo}</td>
                                                        <td>{item.orderNbr}</td>
                                                        <td>{item.orderType}</td>
                                                        <td>{item.itemPOAvailabilityStatus}</td>
                                                        <td>{item.estimatedShipDate}</td>
                                                        <td>{item.cancelDate}</td>
                                                        {/*<td className="table-img"> <span className="svg-holder"><img src={"../../../Images/" + item.statusImg} alt="" className="item-type-image" /></span></td>*/}
                                                        {/*<td>{item.totalItems}</td>*/}
                                                        <td className="table-row" ref={dropdownRef} style={{ position: activeRow === item.orderNbr ? 'absolute' : 'static' }}>
                                                            <InputGroup className="">
                                                                <DropdownButton
                                                                    variant="outline-dark"
                                                                    title={dropdownText[index] || 'Choose'}
                                                                    id="input-group-dropdown-1"
                                                                >
                                                                    {actionMap.get(item.orderNbr + "," + item.itemNbr) !== 0 &&
                                                                        <Dropdown.Item><span className="bold" onClick={() => updateActionCode(item, 0, index)}>Choose</span></Dropdown.Item>
                                                                    }

                                                                    {item.modifiable === true &&
                                                                        <Dropdown.Item><span className="bold" onClick={() => updateActionCode(item, 3, index)}>Modify</span></Dropdown.Item>
                                                                    }

                                                                    <Dropdown.Item><span className="bold" onClick={() => updateActionCode(item, 1, index)}>Cancel</span></Dropdown.Item>
                                                                    <Dropdown.Item><span className="bold" onClick={() => updateActionCode(item, 2, index)}>Retain</span></Dropdown.Item>
                                                                </DropdownButton>
                                                            </InputGroup>
                                                        </td>
                                                        <td>{item.pkgQty}</td>
                                                        <td>
                                                            {item.bOQty > 1 ?
                                                                <DropdownButton
                                                                    variant="outline-dark"
                                                                    title={qtyMap.get(item.orderNbr + "," + item.itemNbr) || item.bOQty}
                                                                    id="backorder-qty"
                                                                    disabled={actionMap.get(item.orderNbr + "," + item.itemNbr) !== 3}
                                                                    className="limit-dropdown"
                                                                >                                                                    
                                                                    {item.bOQty > 1 &&
                                                                        Array.from({ length: item.bOQty }, (_, i) => {
                                                                            const qtyValue = item.bOQty - i;
                                                                            return (
                                                                                <Dropdown.Item key={i} onClick={() => updateQty(item, qtyValue)}>
                                                                                    <span className="bold">{qtyValue}</span>
                                                                                </Dropdown.Item>
                                                                            );
                                                                        })
                                                                    }
                                                                </DropdownButton>
                                                                :
                                                                <>
                                                                    {item.bOQty}
                                                                </>
                                                            }
                                                        </td>
                                                        <td>{item.shipInstructions}</td>
                                                    </tr>
                                                ))}

                                            </tbody>
                                        </Table>
                                    </Col>
                                </Row>

                                <PaginationBar
                                    resultsLength={resultsLength}
                                    pageCount={pageCount}
                                    currentPage={currentPage}
                                    pageResults={pageResults}
                                    tempPage={tempPage}
                                    onTempPageChange={handleChange}
                                    onPageResultsChange={changePageResults}
                                    onPageChange={handlePageClick}
                                />
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row className="mb-4">
                    <Col sm={12} className="text-right">
                        <Button variant="primary" onClick={handleUpdate}>
                            <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                            </svg>
                            UPDATE
                        </Button>
                    </Col>
                </Row>

            </Container>

            <FooterDealer />

            <Modal className="loader-div" id="loader" show={pop} onHide={handleClosePop} size="lg" centered backdrop="static" keyboard={false}>
                <PulseLoader color="#66cc33" size="20px" margin="12px" />
            </Modal>
        </>
    );
}